export default "__VITE_ASSET__BN40X$tP__"